import * as React from 'react'
// context
import TasksListAPI from 'containers/StrategyActions/components/TasksList/layers/API'
import TasksListBL from 'containers/StrategyActions/components/TasksList/layers/BL'
// components
import TasksList from 'components/PageComponents/Home/components/DashboardWidgets/components/StrategyActions/components/Content/components/TasksList'
// types
import { IPlan } from 'types/graphql'

// types
interface Props {
  plan: IPlan
}

const TasksListContainer: React.FC<Props> = ({ plan }) => {
  return (
    <TasksListAPI plan={plan}>
      <TasksListBL>
        <TasksList />
      </TasksListBL>
    </TasksListAPI>
  )
}

export default TasksListContainer
